export const numberRules = {
	validator: (_: any, value: number) =>
		!value || (!isNaN(value) && value >= 0)
			? Promise.resolve()
			: Promise.reject(new Error('Վավեր թիվ չէ'))
};
